import * as React from "react";
import * as Glob from "../Globale";
import * as Compat from "../Compat";
import { BaseComponent } from "./BaseComponent";
import * as Dati from "../Dati";
import { Trad } from ".";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";

interface ICampoNumeroConSegnoProps extends Dati.IBaseProps {
    Valore?: number;
    Minimo?: number;
    Massimo?: number;
    Precisione?: number;
    Icona?: string;
    ValoreNeutro?: number;
    BarraLimiti?: boolean;
    Disabilitato?: boolean;
}

export class CampoNumeroConSegno extends BaseComponent<ICampoNumeroConSegnoProps, {}> {
    private _Valore: string = "0.00";
    private _Minimo: number = -9999999999999.99;
    private _Massimo: number = 9999999999999.99;
    private _Precisione: number = 0;
    private _CSS: string = "";
    private _CSSBase: string = " TextRight";
    private _ValoreNeutroMassimo: number = 0;
    private _ValoreNeutroMinimo: number = 0;
    private _BarraLimiti: boolean = false;
    private _Disabilitato: boolean = false;

    constructor(props: any) {
        super(props);
        this.props.Precisione != undefined ? (this._Precisione = this.props.Precisione) : (this._Precisione = Trad.PrecisioneImporto());
        this.props.Valore != undefined ? (this._Valore = this.DaNumeroATesto(this.props.Valore)) : (this._Valore = "0." + Compat.ES2017_padStart("", this._Precisione, "0"));
        this.props.Minimo != undefined ? (this._Minimo = this.props.Minimo) : (this._Minimo = -9999999999999.99);
        this.props.Massimo != undefined ? (this._Massimo = this.props.Massimo) : (this._Massimo = 9999999999999.99);
        this.props.CSS != undefined ? (this._CSS = this.props.CSS) : (this._CSS = "");
        this.props.Scrittura != undefined ? (this._Scrittura = this.props.Scrittura) : (this._Scrittura = true);

        this.props.ValoreNeutro != undefined ? (this._ValoreNeutroMassimo = this.props.ValoreNeutro) : (this._ValoreNeutroMassimo = this._Massimo);
        this.props.ValoreNeutro != undefined ? (this._ValoreNeutroMinimo = this.props.ValoreNeutro) : (this._ValoreNeutroMinimo = this._Minimo);

        this.props.BarraLimiti != undefined ? (this._BarraLimiti = this.props.BarraLimiti) : (this._BarraLimiti = false);

        this.props.Disabilitato != undefined ? (this._Disabilitato = this.props.Disabilitato) : (this._Disabilitato = false);

        this.ControlloLimiti = this.ControlloLimiti.bind(this);
    }

    private ConfrontaNome(id: string, name: string, campo: string): boolean {
        if (id == campo || name == campo) {
            return true;
        } else if ("Dato." + id == campo || "Dato." + name == campo) {
            return true;
        } else if ("Dati." + id == campo || "Dati." + name == campo) {
            return true;
        }

        return false;
    }

    UNSAFE_componentWillReceiveProps(nextProps: ICampoNumeroConSegnoProps) {
        nextProps.CSS != undefined ? (this._CSS = nextProps.CSS) : (this._CSS = "");
        nextProps.Valore != undefined ? (this._Valore = this.DaNumeroATesto(nextProps.Valore)) : (this._Valore = "0." + Compat.ES2017_padStart("", this._Precisione, "0"));
        nextProps.Minimo != undefined ? (this._Minimo = nextProps.Minimo) : (this._Minimo = -9999999999999.99);
        nextProps.Massimo != undefined ? (this._Massimo = nextProps.Massimo) : (this._Massimo = 9999999999999.99);
        nextProps.BarraLimiti != undefined ? (this._BarraLimiti = nextProps.BarraLimiti) : (this._BarraLimiti = false);
        this._Disabilitato = nextProps.Disabilitato != undefined ? nextProps.Disabilitato : false;
        this._Scrittura = nextProps.Scrittura != undefined ? nextProps.Scrittura : true;

        if (nextProps.RegoleValidazione != undefined) {
            let arrayRegole: any[] = JSON.parse(nextProps.RegoleValidazione);
            for (let i: number = 0; i < arrayRegole.length; i++) {
                if (this.ConfrontaNome(this.props.Id, this.props.Name, arrayRegole[i].Campo)) {
                    Glob.LogInfo(Glob.LogCat.Regole, "Regola per il campo: " + this.props.Id + "/" + this.props.Name, arrayRegole[i].Regole);
                    for (let r: number = 0; r < arrayRegole[i].Regole.length; r++) {
                        if (arrayRegole[i].Regole[r].Azione == "<") this._Massimo = arrayRegole[i].Regole[r].Valore - 0.001;
                        else if (arrayRegole[i].Regole[r].Azione == "<=") this._Massimo = arrayRegole[i].Regole[r].Valore;
                        else if (arrayRegole[i].Regole[r].Azione == ">") this._Minimo = arrayRegole[i].Regole[r].Valore + 0.001;
                        else if (arrayRegole[i].Regole[r].Azione == ">=") this._Minimo = arrayRegole[i].Regole[r].Valore;
                        else if (arrayRegole[i].Regole[r].Azione == "=") {
                            this._Massimo = arrayRegole[i].Regole[r].Valore;
                            this._Minimo = arrayRegole[i].Regole[r].Valore;
                        }
                    }
                }
            }
        }
    }

    private DaNumeroATesto(valore: number): string {
        if (valore < 9999999999999.99 || valore > - 9999999999999.99) {
            return new Intl.NumberFormat(Trad.FormatoLingua(), {
                currency: Trad.FormatoImporto(),
                minimumFractionDigits: this._Precisione,
                maximumFractionDigits: this._Precisione
            }).format(valore);
        } else {
            return "";
        }
    }

    private DaTestoANumero(valore: string): number {
        const negativo = valore.trim().startsWith("-");

        valore = valore.replace(/\D/g, "");

        const numero = Number(valore) / (10 ** this._Precisione);

        return negativo ? -numero : numero;
    }

    public ControlloPunteggiatura(e: React.FormEvent<any>) {
    const valore = e.currentTarget.value;

    if (valore === "-") {
        this._Valore = "-";
        this.forceUpdate();
        return;
    }

    this._Valore = valore;

    if (valore.endsWith(".") || valore.endsWith(",")) {
        this.forceUpdate();
        return;
    }

    const numero = this.DaTestoANumero(valore);

    if (numero !== null) {
        e.currentTarget.value = numero;

        this.props.OnChange(e);
        this._Valore = this.DaNumeroATesto(numero);
    }

    this.forceUpdate();
}


    private OnFieldChange(e: React.FormEvent<any>) {
        console.warn("input", e.currentTarget.value);
        this.ControlloPunteggiatura(e);
    }

    private ControlloLimiti(e: React.FormEvent<any>) {

        const numero = this.DaTestoANumero(e.currentTarget.value);

        if (numero !== null) {
            if (numero < this._Minimo && numero !== this._ValoreNeutroMinimo) {
                Glob.InfoModaleWarning(
                    Trad.Trad("LIMITE INFERIORE SUPERATO"),
                    Trad.TradParam("E' stato inserito un valore inferiore al limite MINIMO accettabile: {1-R}", [this._Minimo])
                );

                this._Valore = this.DaNumeroATesto(this._Minimo);
                e.currentTarget.value = this._Minimo;
                this.props.OnChange(e);

            } else if (numero > this._Massimo && numero !== this._ValoreNeutroMassimo) {
                Glob.InfoModaleWarning(
                    Trad.Trad("LIMITE SUPERIORE SUPERATO"),
                    Trad.TradParam("E' stato inserito un valore superiore al limite MASSIMO accettabile: {1-R}", [this._Massimo])
                );

                this._Valore = this.DaNumeroATesto(this._Massimo);
                e.currentTarget.value = this._Massimo;
                this.props.OnChange(e);
            }
        }

        if (this.props.OnBlur != undefined) {
            this.props.OnBlur(e);
        }
    }

    private SelezionaTutto(e: React.FormEvent<any>) {
        e.currentTarget.select();
    }

    //HTML.push(<div className="progress kt-progress--sm" >
    //    <div className="progress-bar kt--bg-brand" role="progressbar" aria-valuemin={0} aria-valuemax={this._Massimo} aria-valuenow={this.DaTestoANumero(this._Valore)} style={{ width: this.DaTestoANumero(this._Valore) / this._Massimo * 100 + '%' }}></div>
    //</div>);

    public render() {
        let HTML:any[] = [];
        HTML.push(
            <input
                key="input"
                type="text"
                disabled={this._Disabilitato}
                className={this._CSS + this._CSSBase}
                id={this.props.Id}
                name={this.props.Name}
                value = { this._Valore }
                readOnly={!this._Scrittura}
                onChange={e => {
                    this.OnFieldChange(e);
                }}
                onClick={e => {
                    this.SelezionaTutto(e);
                }}
                onBlur={e => this.ControlloLimiti(e)}
                required={this.props.Richiesto != undefined ? this.props.Richiesto : false}
            />
        );

        if (this.props.Icona != undefined) {
            HTML.push(
                <span key="icona" className="kt-input-icon__icon kt-input-icon__icon--right">
                    <span>
                        <i className={this.props.Icona}></i>
                    </span>
                </span>
            );
        }

        if (this._BarraLimiti) {
            HTML.push(
                <div key="barra1" className="progress kt-progress--sm">
                    <div
                        className="progress-bar kt--bg-brand"
                        role="progressbar"
                        aria-valuemin={0}
                        aria-valuemax={this._Massimo}
                        aria-valuenow={this.DaTestoANumero(this._Valore)}
                        style={{
                            width: (this.DaTestoANumero(this._Valore) / this._Massimo) * 100 + "%"
                        }}
                    ></div>
                </div>
            );
            HTML.push(
                <span key="barra2" className="irs-grid-text js-grid-text-0" style={{ left: "0%", marginBottom: "-10px" }}>
                    {this.DaNumeroATesto(this._Minimo)}
                </span>
            );
            HTML.push(
                <span key="barra3" className="irs-grid-text js-grid-text-4 max-progress-bar">
                    {this.DaNumeroATesto(this._Massimo)}
                </span>
            );
        }
        return HTML;
    }
}



// WEBPACK FOOTER //
// ./src/components/CampoNumeroConSegno.tsx